import { useState, useEffect } from 'react'
import 'rc-time-picker/assets/index.css';
import './App.css';
import { Routes, Route } from 'react-router-dom'
import Protected from './components/Protected';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Equipment360 from './components/Equipment360';
import Utilization from './components/Utilization';
import Fuel_Consumption from './components/Fuel_Consumption';
import Geo from './components/Geo';
import Imp_Parameters from './components/Imp_Parameters';
import Impact from './components/Impact';
import Maintenance from './components/Maintenance';
import Operator from './components/Operator';
import Service_Request from './components/Service_Request';
import Incident from './components/Incident';
import Accounts from './components/Accounts';
import Asset_Customer_Form from './components/Asset_Customer_Form';
import Assets_Lists from './components/Assets_Lists';
import Login from './components/Login';
import Asset_User_Mapping from './components/Asset_User_Mapping'
import Service_Request_List from './components/Service_Request_List'
import Shift_Master from './components/Shift_Master';
import My_Equipment from './components/My_Equipment';
import Profile from './components/Profile';
import Dash_Group_Creation from './components/Dash_Group_Creation';
import Dash_Group_Mapping from './components/Dash_Group_Mapping';
import Preventive_Maintenance from './components/Preventive_Maintenance';
import Fuel_Tank_Capacity from './components/Fuel_Tank_Capacity';
import Add_Admin_User from './components/Add_Admin_User';
import Technician_Master from './components/Technician_Master';
import Godrej_User_List from './components/Godrej_User_List';
import Azure_Redirect from './components/azureRedirect'
import Notification from "./components/notification";
import Asset_upload from './components/asset_upload';
import Page404 from "./components/404";
import { getUserInfo } from './components/functions/userInfo'
import CreateGeo from './components/createGeo';
import AssetLocation from './components/AssetLocation';
import Location_Tracking from './components/Location_Tracking';
import {AuthProvider} from './Azure-ad/AuthContext'
import { AzureMapsProvider } from "react-azure-maps"; // not used but it required to load map perfectly.
import Local_Login from './components/Local_Login';

function App() {
  let loginUser;
  let [isLogin, setIsLogin] = useState(false);
  let [adtype, setAdType] = useState('b2b');
  useEffect(() => {
    if (sessionStorage.getItem('userInfo')) {
      loginUser = getUserInfo();
      if (loginUser.token != "" || loginUser.token != null) {
        setIsLogin(true);
      }
    }
  }, []);

  function setLoginState(val) {
    setIsLogin(val);
  }

  function setAdTypeState(val) {
    console.log("from APP:", val);
    setAdType(val);
    if (val == 'b2b') {
      msalInstanceB2b.initialize().then(() => {
        console.log("b2b initialized done");
      });
    }
    else {
      msalInstanceB2c.initialize().then(() => {
        console.log("b2c initialized done");
      });
    }
  }

  return (
    <div className="App" >
      <AuthProvider>
        {
          isLogin ? <><Header />
            <Sidebar style={{ overflowY: 'scroll' }} aapFun={setLoginState}></Sidebar></> : ""
        }
        <Routes>
          <Route path='/' element={<Login aapFun={setLoginState} adFun={setAdTypeState} />}></Route>
          <Route path='/login' element={<Login aapFun={setLoginState} adFun={setAdTypeState} />}></Route>
          <Route path='/locallogin' element={<Local_Login aapFun={setLoginState} adFun={setAdTypeState} />}></Route>
          <Route path='/home' element={<Protected aapFun={setLoginState} cmp={Equipment360} />}></Route>
          <Route path='/utilization' element={<Protected aapFun={setLoginState} cmp={Utilization} />}></Route>
          <Route path='/fuel-consumption' element={<Protected aapFun={setLoginState} cmp={Fuel_Consumption} />}></Route>
          <Route path='/geo' element={<Protected aapFun={setLoginState} cmp={Geo} />}></Route>
          <Route path='/incident' element={<Protected aapFun={setLoginState} cmp={Incident} />}></Route>
          <Route path='/imp-parameter' element={<Protected aapFun={setLoginState} cmp={Imp_Parameters} />}></Route>
          <Route path='/impact' element={<Protected aapFun={setLoginState} cmp={Impact} />}></Route>
          <Route path='/maintenance' element={<Protected aapFun={setLoginState} cmp={Maintenance} />}></Route>
          <Route path='/operator' element={<Protected aapFun={setLoginState} cmp={Operator} />}></Route>
          <Route path='/service-request' element={<Protected aapFun={setLoginState} cmp={Service_Request} />}></Route>
          <Route path='/accounts' element={<Protected aapFun={setLoginState} cmp={Accounts} />}></Route>
          <Route path='/assets-lists' element={<Protected aapFun={setLoginState} cmp={Assets_Lists} />}></Route>
          <Route path='/asset-onboarding' element={<Protected aapFun={setLoginState} cmp={Asset_Customer_Form} />}></Route>
          <Route path='/asset-onboarding/:assetInfoId' element={<Protected aapFun={setLoginState} cmp={Asset_Customer_Form} />}></Route>
          <Route path='/asset-onboarding/:assetInfoId/:opType' element={<Protected aapFun={setLoginState} cmp={Asset_Customer_Form} />}></Route>
          <Route path='/asset-upload' element={<Protected aapFun={setLoginState} cmp={Asset_upload} />}></Route>
          <Route path='/asset-user-mapping' element={<Protected aapFun={setLoginState} cmp={Asset_User_Mapping} />}></Route>
          <Route path='/service-request-list' element={<Protected aapFun={setLoginState} cmp={Service_Request_List} />}></Route>
          <Route path='/shift-master' element={<Protected aapFun={setLoginState} cmp={Shift_Master} />}></Route>
          <Route path='/my-equipment' element={<Protected aapFun={setLoginState} cmp={My_Equipment} />}></Route>
          <Route path='/profile' element={<Protected aapFun={setLoginState} cmp={Profile} />}></Route>
          <Route path='/dashboard-group-creation' element={<Protected aapFun={setLoginState} cmp={Dash_Group_Creation} />}></Route>
          <Route path='/dashboard-group-mapping' element={<Protected aapFun={setLoginState} cmp={Dash_Group_Mapping} />}></Route>
          <Route path='/preventive_maintenance' element={<Protected aapFun={setLoginState} cmp={Preventive_Maintenance} />}></Route>
          <Route path='/fuel_tank_capacity' element={<Protected aapFun={setLoginState} cmp={Fuel_Tank_Capacity} />}></Route>
          <Route path='/adminUser' element={<Protected aapFun={setLoginState} cmp={Add_Admin_User} />}></Route>
          <Route path='/technician-master' element={<Protected aapFun={setLoginState} cmp={Technician_Master} />}></Route>
          <Route path='/godrej-user-List' element={<Protected aapFun={setLoginState} cmp={Godrej_User_List} />}></Route>
          <Route path='/createGeo' element={<Protected aapFun={setLoginState} cmp={CreateGeo} />}></Route>
          <Route path='/location_tracking' element={<Protected aapFun={setLoginState} cmp={Location_Tracking} />}></Route>
          <Route path='/notification' element={<Protected aapFun={setLoginState} cmp={Notification} />}></Route>
          {/* <Route path='/assetlocation/:mapObj' element={<Protected aapFun={setLoginState} cmp={AssetLocation} />}></Route> */}
          <Route path='/assetlocation/:geoName/:loc/:asset' element={<Protected aapFun={setLoginState} cmp={AssetLocation} />}></Route>
          <Route path='/redirect' element={<Azure_Redirect aapFun={setLoginState} />}></Route>
          <Route path='*' element={<Page404 aapFun={setLoginState} />}></Route>
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
